var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddMoreProducts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m70 22-29.763 7.255a1 1 0 0 1-.474 0l-28.526-6.953a1 1 0 0 0-1.237.971v33.629a1 1 0 0 0 .763.971l29 7.07a1 1 0 0 0 .474 0l29-7.07a1 1 0 0 0 .763-.971V35.344"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "m42 33-2 .313M44.5 36 40 37M46 39.5 40 41M69 38l-29 7M69 42l-29 7M69 46l-29 7M69 50l-29 7M69 54l-29 7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m11 22 29-6 29 6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M40 17v12"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m40 29.5 5.747 9.726a2 2 0 0 0 2.191.927l24.986-6.031a2 2 0 0 0 1.272-2.929L69 22M10 23l-5.013 7.326c-.52.76.176 1.758 1.068 1.535L9.5 31"
})));
export default SvgAddMoreProducts;